module.exports = __webpack_public_path__ + "static/media/barbell-plate-250.c6a352fb.png";